import { render } from "./CheckBoxInput.vue?vue&type=template&id=632f17d2&scoped=true&ts=true"
import script from "./CheckBoxInput.vue?vue&type=script&lang=ts"
export * from "./CheckBoxInput.vue?vue&type=script&lang=ts"

import "./CheckBoxInput.vue?vue&type=style&index=0&id=632f17d2&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632f17d2"]])

export default __exports__